import axios from "axios";
import { getSession } from "next-auth/react";
import moment from "moment";
import { endpointUrl } from "../../../services/connection";

export async function getScore(email: string, token: string) {
  const response = await axios
    .get(`${endpointUrl}/${email}/total_score`, {
      headers: { Authorization: `Token ${token}` },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getUser(email: string, token: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/user/${email}`, {
      headers: { Authorization: `Token ${token}` },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getMinifiedUser(email: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-minified-user/${email}`, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function updateUnactivatedRootUser(
  email: string,
  password: string,
  selectedPackage: any
) {
  const data = { email, password, selectedPackage };
  const response = await axios
    .post(`${endpointUrl}/user-account/update-unactivated-root-user`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getSessionDetails() {
  const response = await getSession()
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function userLogin(email: string, password: string) {
  const data2 = {
    email,
    password,
  };
  const { data } = await axios.post(`${endpointUrl}/user-account/login`, data2);
  return data;
}

export async function verifyAccount(email: string) {
  const response = await axios
    .get(`${endpointUrl}/account/verify/${email}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getProfileData(token: string, email: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/user_profile/${email}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .catch((err) => err.message);
  return response;
}

export async function getAllUserGroup(token: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/all-usergroup`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .catch((err) => err.message);
  return response;
}

export async function getCoursesByGroup(token: string, groupId: number) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-courses-by-group/${groupId}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .catch((err) => err.message);
  return response;
}

export async function getLearnersByGroup(token: string, groupId: number) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-learners-by-group/${groupId}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .catch((err) => err.message);
  return response;
}

export async function getUserGroupById(token: string, id: number) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-usergroup-by-id/${id}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .catch((err) => err.message);
  return response;
}

export async function revokeToken(email: any) {
  const response = await axios
    .get(`${endpointUrl}/user-account/logout/${email}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function validatePasswordResetToken(token: any) {
  const response = await axios
    .get(`${endpointUrl}/user-account/validate_password_reset_token/${token}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function sendResetLink(email: string) {
  const data = {
    email,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/send-reset-link`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function addNewUserGroup(group: string, token: string) {
  const data = {
    group,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/add-new-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createNewPassword(
  passwordResetToken: any,
  password: string,
  email: string
) {
  const data = {
    password1: password,
    password2: password,
    token: passwordResetToken,
    email,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/set_new_password`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createNewAdminPassword(
  email: any,
  password: string,
  token: string
) {
  const data = {
    email,
    password,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/change_password`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createNewUser(
  firstName: string,
  lastName: string,
  email: string,
  isActive: boolean,
  token: string,
  group: string
) {
  const data = {
    firstName: firstName,
    surname: lastName,
    email,
    is_active: isActive,
    group,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/create-user`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createTenantRootUser(
  firstName: string,
  lastName: string,
  email: string,
  isActive: boolean,
  password: string,
  selectedPackage: any
) {
  const data = {
    firstName: firstName,
    surname: lastName,
    email,
    password,
    is_active: isActive,
    selectedPackage,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/create-tenant-root-user`, data, {})
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function createNewUserGroup(
  group: string,
  description: string,
  token: string
) {
  const data = {
    group,
    description,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/add-new-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function updateUserGroup(
  title: string,
  description: string,
  id: number,
  token: string
) {
  const data = {
    id,
    title,
    description,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/update-user-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function removeCourseFromGroup(
  course_id: number,
  token: string,
  groupTitle: string
) {
  const data = {
    course_id,
    groupTitle,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/remove-course-from-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function removeUserFromGroup(user_id: number, token: string) {
  const data = {
    user_id,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/remove-user-from-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getAllUsers(token: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-all-users`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function deleteUserGroup(token: string, groupId: number) {
  const data = {
    id: groupId,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/delete-user-group`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function getUserByEmail(token: string, email: string) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-user/${email}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function UpdateUserLoginStatus(userToken: string) {
  const data = {
    is_first_time: false,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/update-login-status`, data, {
      headers: {
        Authorization: `Token ${userToken}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function UpdateUserPasswordMain(
  email: string,
  oldPassword: string,
  newPassword: string,
  userToken: string
) {
  const data = {
    new_password: newPassword,
    old_password: oldPassword,
    email,
  };
  const response = await axios
    .post(`${endpointUrl}/user-account/update_password`, data, {
      headers: {
        Authorization: `Token ${userToken}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function updateCrestlearnUser(
  userId: number,
  firstName: string,
  lastName: string,
  isActive: boolean,
  role: string,
  enrollmentDate: string,
  expirationDate: string,
  createMs365: boolean,
  token: string,
  ms365UserId: string,
  email: string,
  deactivateMs365User: boolean,
  billingSetupStatus: string,
  autoRenewalStatus: string,
  autoRenewalTries: number,
  stripeId: string,
  nextRenewalDate: string,
  isAdmin: boolean,
  isSuperAdmin: boolean,
  userHasAccount: boolean
) {
  const data = {
    first_name: firstName,
    last_name: lastName,
    is_active: isActive,
    role: role,
    create_ms365: createMs365,
    subscription_date: moment(enrollmentDate).format("YYYY-MM-DD"),
    subscription_expiration_date: moment(expirationDate).format("YYYY-MM-DD"),
    ms365_user_id: ms365UserId,
    email: email,
    deactivate_account: deactivateMs365User,

    billing_setup_status: billingSetupStatus,
    autorenewal_status: autoRenewalStatus,
    autorenewal_tries: Number(autoRenewalTries),
    stripe_id: stripeId,
    next_renewal_trial_date: nextRenewalDate,
    is_staff: isAdmin,
    is_superuser: isSuperAdmin,
    has_ms365_account: userHasAccount,
  };

  // console.log("testing data",data)

  const response = await axios
    .put(`${endpointUrl}/user-management/update-user/${userId}/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function UpdateUserPassword(
  email: string,
  newPassword: string,
  userToken: string
) {
  const data = {
    password: newPassword,
  };
  const response = await axios
    .put(
      `${endpointUrl}/user-management/change-user-password/${email}/`,
      data,
      {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      }
    )
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function getCrestlearnUsersByOrder(
  orderBy: string,
  key: number,
  token: string
) {
  const response = await axios
    .get(
      `${endpointUrl}/user-management/get-all-users/${orderBy.toUpperCase()}/${key}/`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    )
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function createUserRole(token: string, role: string) {
  const data = {
    role,
  };
  const response = await axios
    .post(`${endpointUrl}/user-management/create-new-role/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function getAvailableRole(token: string) {
  const response = await axios
    .get(`${endpointUrl}/user-management/get-all-roles/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => res)
    .catch((err) => err.message);

  return response;
}

export async function createNewTenantTrial(
  firstName: string,
  lastName: string,
  email: string,
  isActive: boolean,
  password: string,
  companyName: string,
  companySize: number,
  industry: string,
  location: string
) {
  const data = {
    firstName: firstName,
    surname: lastName,
    email,
    is_active: isActive,
    password,
    companyName,
    companySize,
    industry,
    location,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/create-trial-user`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function verifyCode(
  email: any,
  companyName: any,
  verificationCode: string
) {
  const data = {
    email,
    companyName,
    verificationCode,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/verify-code`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function requestVerificationCode(email: any, companyName: any) {
  const data = {
    email,
    companyName,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/request-code`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function scheduleMeeting(
  businessName: string,
  companySize: string,
  industry: string,
  additionalInformation: string,
  email: string,
  location: string,
  phone: string,
  scheduleDate: string,
  scheduleTime: string,
  preferedDate: string,
  preferedTime: string,
  whatToDiscuss: string
) {
  const data = {
    businessName,
    companySize,
    industry,
    additionalInformation,
    email,
    location,
    phone,
    scheduleDate,
    scheduleTime,
    preferedDate,
    preferedTime,
    whatToDiscuss,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/new-account-request`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function checkTenantEmail(email: string) {
  const data = {
    email,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/tenant-exist`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getTenant(account_id: string | string[]) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-tenant/${account_id}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getTenantById(tenantId: Number) {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-tenant-by-id/${tenantId}`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function updateTenant(accountDetails: any) {
  const response = await axios
    .post(`${endpointUrl}/user-account/create-business-account`, accountDetails)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getCountryData() {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-country-data`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function getCountries() {
  const response = await axios
    .get(`${endpointUrl}/user-account/get-countries`)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export async function contactUsFromLandingPage(
  email: string,
  location: string,
  phone: string,
  reasons: string,
  reasonsDetail: string,
  contact_phone: boolean,
  contact_email: boolean
) {
  const data = {
    email,
    location,
    phone,
    reasons,
    reasonsDetail,
    contact_phone,
    contact_email,
  };

  const response = await axios
    .post(`${endpointUrl}/user-account/contact-us`, data)
    .then((res) => res)
    .catch((err) => err.message);
  return response;
}

export const getViewArea = (tabClicked: string) => {
  const element = document.getElementById(
    `scrollTab${tabClicked.replaceAll(" ", "")}`
  );
  // element?.scrollIntoView({ behavior: "smooth", block: "start" });

  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset - 250;
    // 80; // header height

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
};

export function formatDuration(seconds: number) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
    2,
    "0"
  )}:${String(secs).padStart(2, "0")}`;
}

export function sumDurations(times: any) {
  const totalSeconds = times.reduce(
    (
      total: any,
      time: {
        split: (arg0: string) => {
          (): any;
          new (): any;
          map: { (arg0: NumberConstructor): [any, any, any]; new (): any };
        };
      }
    ) => {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return total + (hours * 3600 + minutes * 60 + seconds);
    },
    0
  );

  return formatDuration(totalSeconds);
}

export function addCourseDurations(time1: string, time2: string) {
  const toSeconds = (time: string) => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const totalSeconds = toSeconds(time1) + toSeconds(time2);

  return formatDuration(totalSeconds);
}
